export default "__VITE_ASSET__DtcuG_Qv__"